import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] caught error:', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.error) {
      const isChunkError =
        /loading chunk|failed to fetch dynamically imported module|importing a module script failed/i.test(
          String(this.state.error?.message || '')
        );

      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem',
            background: '#0a0a0f',
            color: '#fff',
            fontFamily: 'system-ui, sans-serif',
          }}
        >
          <div style={{ maxWidth: 480, textAlign: 'center' }}>
            <h1 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>
              {isChunkError ? 'Nueva versión disponible' : 'Algo salió mal'}
            </h1>
            <p style={{ color: '#bbb', marginBottom: '1.5rem' }}>
              {isChunkError
                ? 'Se publicó una actualización. Recargá la página para continuar.'
                : 'La aplicación encontró un error inesperado. Si persiste, contactá soporte.'}
            </p>
            <button
              onClick={this.handleReload}
              style={{
                padding: '0.75rem 1.5rem',
                fontSize: '1rem',
                background: '#fbbf24',
                color: '#000',
                border: 'none',
                borderRadius: 8,
                cursor: 'pointer',
                fontWeight: 600,
              }}
            >
              Recargar
            </button>
            {!isChunkError && this.state.error?.message && (
              <details style={{ marginTop: '1.5rem', textAlign: 'left' }}>
                <summary style={{ cursor: 'pointer', color: '#888' }}>Detalles técnicos</summary>
                <pre
                  style={{
                    marginTop: '0.5rem',
                    padding: '0.75rem',
                    background: '#1a1a24',
                    borderRadius: 6,
                    fontSize: '0.75rem',
                    overflow: 'auto',
                    color: '#f87171',
                  }}
                >
                  {String(this.state.error?.message)}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
